import { pxToEm } from 'util/pxToEm';
import { styled, Box } from '@mui/material';

export const GridTableHead = styled(Box)(({ theme }) => ({
  width: '100.1%',
  paddingTop: 20,
  paddingBottom: 8,
  marginBottom: 8,
  fontSize: pxToEm(16),
  fontWeight: 500,
  whiteSpace: 'nowrap',
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
}));
